import { InputHTMLAttributes } from 'react'

interface FormInputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
}

const FormInput = ({
  label,
  id,
  className,
  ...props
}: FormInputProps & { className?: string }) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label
        htmlFor={id}
        className="text-xs font-medium text-gray-600 uppercase tracking-wide"
        style={{ fontFamily: "'Outfit', sans-serif", fontWeight: 500 }}
      >
        {label}
      </label>
      <input
        id={id}
        className={`w-full px-4 py-3 rounded-xl border border-gray-300 bg-gray-50 text-gray-900 text-sm
                   placeholder:text-gray-400 focus:outline-hidden focus:ring-2 focus:ring-[#C0FD72]/50 focus:border-[#C0FD72]
                   transition-all duration-200 ${className || ''}`}
        style={{ fontFamily: "'Outfit', sans-serif" }}
        {...props}
      />
    </div>
  )
}

export default FormInput
